import { motion } from "framer-motion";

export default function SectionHeading({
    eyebrow,
    title,
    sub,
    align = "center",
    dark = false,
}) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6 }}
            className={`max-w-2xl ${
                align === "center" ? "mx-auto text-center" : "text-left"
            }`}
        >
            <p
                className={`text-xs font-semibold uppercase tracking-[0.22em] ${
                    dark ? "text-emerald-300" : "text-emerald-700"
                }`}
            >
                {eyebrow}
            </p>
            <h2
                className={`mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${
                    dark ? "text-white" : "text-slate-900"
                }`}
            >
                {title}
            </h2>
            {sub && (
                <p
                    className={`mt-3 text-sm leading-relaxed sm:text-base ${
                        dark ? "text-emerald-100/70" : "text-slate-600"
                    }`}
                >
                    {sub}
                </p>
            )}
        </motion.div>
    );
}
